import { createSlice } from "@reduxjs/toolkit";

const drmSubmitTableDataSlice = createSlice({
  name: "submitDrmtTableData",
  initialState: {
    sagaIds: [],
    isLoading: false,
    errorMessage: undefined,
    successMessage: undefined,
  },
  reducers: {
    setSubmitDrmTableData: (state) => {
      state.isLoading = true;
    },
    setSubmitDrmTableDataSuccess: (state, action) => {
      state.isLoading = false;
      state.successMessage = action.payload;
    },
    setSubmitDrmTableDataFailure: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    setResetSubmitDrmTableDataState: (state) => {
      state.isLoading = false;
      state.errorMessage = undefined;
      state.successMessage = undefined;
    },
  },
});

export const {
  setSubmitDrmTableData,
  setSubmitDrmTableDataSuccess,
  setSubmitDrmTableDataFailure,
  setResetSubmitDrmTableDataState,
} = drmSubmitTableDataSlice.actions;

export default drmSubmitTableDataSlice.reducer;
